// +----------------------------------------------------------------------
// | Desc: 全局状态管理库
// +----------------------------------------------------------------------
export default {
  zhuanKind: {
    100: "发明专利",
    200: "实用新型",
    300: "外观设计",
  },
  zhuanType: {
    100: "未下证",
    200: "已下证",
    300: "未标记",
    0: "未标记",
  },
  zhuanDeadlineType: {
    100: "办登截止日",
    200: "恢复截止日",
    400: "绝限截止日",
    500: "年费截止日",
  },
  zhuanliStatus: {
    100: "待售中",
    200: "已锁定",
    300: "仅排队",
    400: "已售出",
    500: "已下架",
  },
  toolType: {
    50: "仅下单",
    100: "取消锁定",
    200: "锁定延时",
    300: "完成出售",
    400: "取消排队",
    500: "定金插队",
    600: "排队转锁定",
    700: "锁定专利",
    800: "预约排队",
    900: "强制待售",
    1000: "强制下架",
    1100: "强制删除",
    1200: "接单并锁定专利",
    1300: "接单并预约排队",
    1400: "拒绝接单",
  },
  orderStatus: {
    50: "急需接单",
    100: "锁定专利",
    200: "排队",
    300: "出售专利",
    400: "取消预约",
  },
  orderStatusBG: {
    50: "BG6",
    100: "BG1",
    200: "BG8",
    300: "BG4",
    400: "BG10",
  },
};
